

import React, { memo } from 'react';
import Icon from '../../Icon';
import { getSortColor } from '../utils/sortValue';








const SortIcon = (props) => {
  const { name, isActive, isHovered, size } = props;

  const color = getSortColor(isActive, isHovered);

  return (
    <Icon
      className="sort-icon"
      name={name}
      size={size}
      color={color} />);


};

export default memo(SortIcon);